/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */
import { Component, OnInit } from '@angular/core';
import { UserModel } from '../user/user.model';
import { UsersService } from '../users.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LazyLoadEvent, SelectItem } from 'primeng/api';

@Component({
  selector: 'auth-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  providers: [UsersService],
})
export class UsersComponent implements OnInit {
  users: Array<UserModel> | undefined = undefined;
  latestEvent: LazyLoadEvent | undefined = undefined;
  totalRecords = 10;
  activeOpt: Array<SelectItem> | undefined = undefined;
  filterActive: boolean | undefined = undefined;

  constructor(
    private usersService: UsersService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const options = ['active', 'inactive', 'all'];
    const optTransLabels = options.map((item) => `auth.activeOpts.${item}`);

    this.translateService.stream(optTransLabels).subscribe((res) => {
      this.activeOpt = [
        { label: res['auth.activeOpts.all'], value: null },
        { label: res['auth.activeOpts.active'], value: true },
        { label: res['auth.activeOpts.inactive'], value: false }
      ];
    });

    /*this.latestEvent = {
        first : 0,
        rows: 10,
        filters: {}
    };
    this.latestEvent.filters["active"] = {
        value: true,
        matchMode: 'equals'
    };

    this.getData(this.latestEvent);*/
  }

  edit(user: UserModel) {
    this.router.navigate(['../user', user.uuid], {
      relativeTo: this.route,
    });
  }

  newUser() {
    this.router.navigate(['../user', ''], {
      relativeTo: this.route,
    });
  }

  loadUsersLazy(event: any) {
    this.latestEvent = event;
    this.getData(event);
  }

  getData(event: any) {
    this.usersService.getUsers(event).subscribe((data) => {
      this.users =
        data['_embedded'].entityModels || data['_embedded'].entityModelList;
      this.totalRecords = data['page'].totalElements;
    });
  }
}
